module.exports = __webpack_public_path__ + "static/img/img49.1b876dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img49.png
// module id = V0EA
// module chunks = 1